import { BlockEditProps } from "@wordpress/blocks";
import React, { useCallback } from "react";
import Select from "react-select";
import Creatable from "react-select/creatable";
import type { BlockAttributes } from "./block.json";
import {
  InspectorControls,
  RichText,
  useBlockProps,
  useInnerBlocksProps,
} from "@wordpress/block-editor";
import "../slider/swiper";

const ALLOWED_BLOCKS = ["yellowtree/profile-angestellte"];
export default function WrapperEditor(props: BlockEditProps<BlockAttributes>) {
  const blockProps = useBlockProps({ className: "" });
  const innerBlocksProps = useInnerBlocksProps(
    useBlockProps({
      className: "",
    }) as unknown as Record<string, unknown>,
    {
      allowedBlocks: ALLOWED_BLOCKS,
      template: [["yellowtree/profile-angestellte"]],
      templateLock: "all",
    }
  );

  return (
    <>
      <div {...blockProps}>
        <div {...innerBlocksProps} />;
      </div>
    </>
  );
}
